/*
    JS functions and handlers that have not been moved to separate library yet
*/
import moment from 'moment'

document.addEventListener('DOMContentLoaded', function() {
  $('#event_performed_on').on('change', event_performed_on_change);
  $('#event_performed_on').on('changeDate', event_performed_on_change);
})

function event_performed_on_change(e) {
    const value  = $(this).val();
    const period = $(this).data('period');
    const unit   = $(this).data('period-unit');    
    if(period && unit){
      const result = moment(value,I18n.t("date.formats.moment")).add(period, unit).format(I18n.t("date.formats.moment"));
      $('#event_valid_until').val(result);
    }
}
